module.exports = __webpack_public_path__ + "static/media/solicitud-inscripcion-posgrado.d014658f.pdf";